export default __webpack_public_path__ + "static/media/alexa2.03aa3c8c.webp";